import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const namespaced = true

export default {
  namespaced,
  state () {
    return {
      statusOrder: [],
      business: [],
      pedidosReport: []
    }
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/relatorios/index.js